import { render, staticRenderFns } from "./BlocItem.vue?vue&type=template&id=97c1999e&lang=pug&"
import script from "./BlocItem.vue?vue&type=script&lang=js&"
export * from "./BlocItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97c1999e')) {
      api.createRecord('97c1999e', component.options)
    } else {
      api.reload('97c1999e', component.options)
    }
    module.hot.accept("./BlocItem.vue?vue&type=template&id=97c1999e&lang=pug&", function () {
      api.rerender('97c1999e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/blocmenu/BlocItem.vue"
export default component.exports